import React, { Fragment } from 'react';
import classNames from 'classnames';
import { DiagnosticPackageStatuses, DiagnosticPackageStatusNames } from './constants';
import styles from './DiagnosticPackageStepper.module.css';

const DEFAULT_STATUS = 'Loading';

const steps = [
  DEFAULT_STATUS,
  DiagnosticPackageStatuses.GENERATING,
  DiagnosticPackageStatuses.LINKING,
  DiagnosticPackageStatuses.UPLOADING,
  DiagnosticPackageStatuses.DECRYPTING
];

function DiagnosticPackageStepper({ status = DEFAULT_STATUS }) {
  return (
    <div
      className={classNames(styles.root, {
        [styles.done]: status === DiagnosticPackageStatuses.COMPLETED,
        [styles.error]: status === DiagnosticPackageStatuses.ERROR
      })}
    >
      {steps.map((step) => (
        <DiagnosticPackageStepperStep key={step} value={step} status={status} />
      ))}
    </div>
  );
}

export default DiagnosticPackageStepper;

function DiagnosticPackageStepperStep({ value, status }) {
  const index = steps.indexOf(value);
  const activeIndex = steps.indexOf(status);

  return (
    <Fragment>
      {index > 0 && (
        <div
          className={classNames(styles.path, {
            [styles.next]: index === activeIndex,
            [styles.prev]: index < activeIndex
          })}
        />
      )}
      <div
        className={classNames(styles.step, {
          [styles.next]: index === activeIndex,
          [styles.prev]: index < activeIndex
        })}
        title={DiagnosticPackageStatusNames[value] ?? 'Requesting diagnostic package'}
      />
    </Fragment>
  );
}
